import React from "react";
import {useState, useEffect} from 'react';
import {fromJS} from 'immutable';
import MAP_STYLE from './Map3Style.json';
import { withStyles} from "@material-ui/styles";
import { Grid, FormControlLabel, Switch, Tooltip, Typography, Slider, Radio, RadioGroup, Button, ButtonGroup } from "@material-ui/core/";

const defaultMapStyle = fromJS(MAP_STYLE);
const defaultLayers = defaultMapStyle.get('layers');

const PrettoSlider = withStyles({
  root: {
    color: "rgb(190, 215, 71)",
    height: 2,
  },
  thumb: {
    height: 16,
    width: 16,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -6,
    marginLeft: -7,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50%)",
  },
  track: {
    height: 6,
    borderRadius: 4,
  },
  rail: {
    height: 6,
    borderRadius: 4,
  },
  mark: {
    height: 11,
  },
})(Slider);

const LayerTooltip = withStyles({
  tooltipPlacementRight: {
    left: "6px",
  },
})(Tooltip);

const marks = [
  {
    value: 2016,
    label: "'16",
  },
  {
    value: 2017,
    label: "'17",
  },
  {
    value: 2018,
    label: "'18",
  },
  {
    value: 2019,
    label: "'19",
  },
  {
    value: 2020,
    label: "'20",
  },
];

function changeTheMap({visibility}, activeStyle, sliderValue, activeLayer, activeYear, switchState) {
  let layers = defaultLayers
    .filter(layer => {
      const style = layer.getIn(["metadata", "style"]);
      const disturbanceLayers = layer.getIn(["metadata", "data"]);
      const id = layer.get('id');
      const layerId = activeLayer + " " + activeYear;
      const overviewLayerId = "Overview " + activeLayer + " " + activeYear;

      if (switchState === true){
        if (id === layerId || id === overviewLayerId) {
        }
        return (
            visibility[id] || style === activeStyle ||  id === layerId || disturbanceLayers || id === overviewLayerId
      );
      } else {
        return (
            visibility[id] || style === activeStyle ||  id === layerId || id === overviewLayerId
      );
      }
    });
      layers = layers.map((layer) => {
        const style = layer.getIn(["metadata", "style"]);
        const type = layer.get("type");
        const newPaintValue = sliderValue * 0.01;
        if (style === "none" && type === "raster") {
          layer = layer.setIn(["paint", "raster-opacity"], newPaintValue);
        }
        return layer;
      });

  return defaultMapStyle.set('layers', layers);
}

const Map3Control = (props) => {
  
  const [visibility] = useState({
    // "Forest Disturbance": true,
    'Ecoregions': true
  });
  const [activeStyle, setActiveStyle] = useState("darkSimple");
  const [sliderValue, setSliderValue] = useState(75);
  const [activeYear, setActiveYear]= useState("2016");
  const activeLayer = props.activeLayer;
  const setActiveLayer = props.setActiveLayer;
  const switchState = props.switchState;
  const setSwitchState = props.setSwitchState;


  useEffect(() => {
    props.onChange(changeTheMap({visibility}, activeStyle, sliderValue, activeLayer, activeYear, switchState));
  }, [visibility, activeStyle, sliderValue, activeLayer, activeYear, switchState]);

  return (
    <div>
      <div className="styleButtons">
        <ButtonGroup
          variant="contained"
          color="primary"
          aria-label="contained primary button group"
        >
          <Button
            value={"satellite"}
            onClick={(e) => setActiveStyle(e.currentTarget.value)}
          >
            Satellite
          </Button>
          <Button
            value={"darkSimple"}
            onClick={(e) => setActiveStyle(e.currentTarget.value)}
          >
            Dark
          </Button>
          <Button
            value={"light"}
            onClick={(e) => setActiveStyle(e.currentTarget.value)}
          >
            Light
          </Button>
        </ButtonGroup>
      </div>

      <div className="control-panel-map3">
        <RadioGroup
          aria-label="forest structure"
          name="forest structure"
          value={activeLayer}
          onChange={(evt) => setActiveLayer(evt.target.value)}
        >
          <LayerTooltip placement="right" title={<><p noGutter style={{fontSize: "12.5px", zIndex: 50, padding: "3px"}}> The degree of alteration of the natural environment through the planting and harvesting of crops as well as grazing impacts on pasturelands.</p></>} arrow>
            <FormControlLabel
              className="formControlLabel"
              value="Canopy Cover"
              control={<Radio />}
              label="Canopy Cover"
            />
          </LayerTooltip>

          <LayerTooltip placement="right" title={<><p noGutter style={{fontSize: "12.5px", zIndex: 50, padding: "3px"}}> Forest biomass is the cumulative amount of wood mass of a tree aboveground. It is a common and important metric for carbon stock accounting, habitat quality assessment, and forest health.</p></>} arrow>
          <FormControlLabel
            className="formControlLabel"
            value="Biomass"
            control={<Radio />}
            label="Biomass"
          />
          </LayerTooltip>

          <LayerTooltip placement="right" title={<><p noGutter style={{fontSize: "12.5px", zIndex: 50, padding: "3px"}}> Forested basal area is a measure of forest density through taking the cross sectional area of trees within a sample, typically expressed in square feet of basal area per acre. Basal area impacts the fire hazard and risk, as well as the modeling of potential species distributions.</p></>} arrow>
          <FormControlLabel
            className="formControlLabel"
            value="Basal Area"
            control={<Radio />}
            label="Basal Area"
          />
          </LayerTooltip>

          <LayerTooltip placement="right" title={<><p noGutter style={{fontSize: "12.5px", zIndex: 50, padding: "3px"}}> In this model, we classified pixels based on a labeling definition of ‘conifer’ or ‘deciduous’, if that type made up 80% of the composition in the area of a plot sample. A label of ‘mixed’ was assigned If there were not 80% trees of either conifer or deciduous type. A label of ‘dead’ was given to plots where 80% of the trees were recorded as standing dead. Pixels where no trees were estimated present were labeled as ‘none’.</p></>} arrow>
          <FormControlLabel
            className="formControlLabel"
            value="Class"
            control={<Radio />}
            label="Forest Type"
          />
          </LayerTooltip>

        </RadioGroup>
      </div>

      <div className="control-panel-map3-2">
        <Grid container>
          <Grid item xs={12}>
            <div style={{margin: "-5px", marginBottom: "-13px"}}>
              <p className="title">Year:</p>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div>
              <div>
                <PrettoSlider
                  value={activeYear}
                  min={2016}
                  max={2020}
                  step={1}
                  marks={marks}
                  onChange={(event, value) => setActiveYear(value)}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="map3-opacity">
        <Typography className="title">
          Opacity: <span id="slider-value">{sliderValue}%</span>
        </Typography>
        <PrettoSlider
          id="slider"
          min={0}
          max={100}
          step={1}
          value={sliderValue}
          onChange={(event, value) => {
            setSliderValue(value);
          }}
        />
      </div>

      <div className="control-panel-map3-3">
      <LayerTooltip placement="right" title={<><p noGutter style={{fontSize: "12.5px", zIndex: 50, padding: "3px"}}> This layer displays perimeters for wildland fire incidents that meet the following criteria:
      Categorized in the IRWIN (Integrated Reporting of Wildland Fire Information) integration service as a valid Wildfire (WF), Prescribed Fire (RX), or Incident Complex (CX) record with a Fire Discovery Date in the years of 2016-2020 by the Wildland Fire Interagency Geospatial Services (WFIGS) 
      </p></>} arrow>
        <Grid container>
          <Grid item xs={9}>
            <p className={"title"}>Fire Boundary</p>
          </Grid>
          <Grid item xs={3}>
            <Switch
              checked={switchState}
              onChange={(evt) => setSwitchState(evt.target.checked)}
              name="forestDisturbance"
              inputProps={{ "aria-label": "secondary checkbox" }}
            />
          </Grid>
        </Grid>
        </LayerTooltip>
        <p style={{textAlign: "center",}}>*Select a red Fire Boundary to see graph data*</p>
      </div>
    </div>
  );
}

export default React.memo(Map3Control);
